<section class="sg-card mb-4" 
    [ngClass]="{'sg-card--disabled': card?.disabled, 'sg-card--list': layout === 'list', 'sg-card--link': card.linkTo, 'sg-card--secondary-bg': card?.cardBackgroundStyle }"
    *ngIf="card">
    
    <ng-template [ngIf]="isGrid" [ngIfElse]="landscape">

        <ng-template [ngIf]="card.linkTo?.routerLink" [ngIfElse]="gridCard">
            <a [routerLink]="card.linkTo.routerLink">
                <ng-container *ngTemplateOutlet="gridCard"></ng-container>
            </a>
        </ng-template>

    </ng-template>

</section>


<ng-template #gridCard>

    <mlp-ng-image [title]="card.name" [alt]="card.name" [image]="card?.images" class="sg-card__image rounded-top mb-4">
        <ng-container *ngTemplateOutlet="badge; context: {class: ''}"></ng-container>
        
    </mlp-ng-image>

    <section class="col-12 sg-card__body">

        <ng-container *ngTemplateOutlet="badge_icon"></ng-container>

        <ng-container *ngTemplateOutlet="heading; context: {class: ''}"></ng-container>

        <ng-container *ngTemplateOutlet="list; context: {col: '', data: card.list}"></ng-container>

    </section>

    <section class="col-12 mt-2">
        <ng-container *ngTemplateOutlet="footer; context: {col: ''}"></ng-container>
    </section>

</ng-template>


<ng-template #landscape>

    <ng-template [ngIf]="card.linkTo?.routerLink" [ngIfElse]="landscapeCard">
        <a [routerLink]="card.linkTo.routerLink">
            <ng-container *ngTemplateOutlet="landscapeCard"></ng-container>
        </a>
    </ng-template>

</ng-template>


<ng-template #landscapeCard>

    <section class="row mb-3 mb-md-0">

        <section class="col-4 col-lg-4 col-xl-3 pr-0 pr-md-3 position-relative">
            <mlp-ng-image [title]="card.name" [image]="card?.images" class="sg-card__image rounded-left"></mlp-ng-image>
            <ng-container *ngTemplateOutlet="badge_icon; context: {class: '-landscape'}"></ng-container>
        </section>

        <section class="col-8 col-lg-8 col-xl-9 sg-card__body sg-card__body--no-height">

            <div class="pt-md-3 pr-md-3">

                <ng-container *ngTemplateOutlet="heading; context: {class: 'sg-card__title--landscape mb-0'}"></ng-container>
                <ng-container *ngTemplateOutlet="badge; context: {class: 'sg-card__badge--relative'}"></ng-container>
    
                <section class="sg-card__body sg-card__body--no-height row align-items-end mt-3 mb-0 pb-md-3 sg-card__hidden-md-down">
    
                    <ng-container *ngTemplateOutlet="list; context: {col: 'col-4', data: card.listSplit}"></ng-container>
                    <ng-container *ngTemplateOutlet="list; context: {col: 'col-4', data: card.listSplitTwo}"></ng-container>
                    <ng-container *ngTemplateOutlet="footer; context: {col: 'col-4 sg-card__footer--no-pb', copy: true}"></ng-container>
                    
                </section>

            </div>
    
        </section>
        
    </section>
    
    <section class="sg-card__body sg-card__body--no-height row mb-3 d-md-none">
        <ng-container *ngTemplateOutlet="list; context: {col: 'col-6', data: card.listSplit}"></ng-container>
        <ng-container *ngTemplateOutlet="list; context: {col: 'col-6', data: card.listSplitTwo}"></ng-container>
    </section>

    <section class="col-12 px-0 d-md-none">
        <ng-container *ngTemplateOutlet="footer; context: {col: ''}"></ng-container>
    </section>

</ng-template>


<ng-template #list let-default let-col="col" let-data="data">
    <mlp-ng-list class="{{ col }}" [list]="data"></mlp-ng-list>
    <ng-content></ng-content>
</ng-template>


<ng-template #footer let-default let-col="col" let-copy="copy">
    <footer class="sg-card__footer {{ col }}">
        <ng-container *ngIf="!card.disabled && card.toEvent" >
            {{ card.toEvent }} 
        </ng-container>
        &nbsp;
        <mlp-ng-icon-nav class="pull-right" [links]="card.links" (visibility)="menuDisplayChanges($event)" *ngIf="!card.linkTo">
            <!-- https://github.com/angular/angular/issues/9173 -->
            <ng-content select=[links] *ngIf="copy"></ng-content>
            <!-- https://github.com/angular/angular/issues/9173 -->
            <ng-content select=[links-copy] *ngIf="!copy"></ng-content>
            <mlp-ng-add-to-calendar [event]="card.event" *ngIf="card.event && addToCalendarVisible"></mlp-ng-add-to-calendar>
        </mlp-ng-icon-nav>
    </footer>
</ng-template>


<ng-template #badge let-default let-class="class">
    <mlp-ng-badge *ngIf="card?.badge" [badge]="card?.badge" class="sg-card__badge {{ class }}"></mlp-ng-badge>
</ng-template>


<ng-template #badge_icon let-default let-class="class">
    <mlp-ng-icon *ngIf="card?.mainIcon" class="sg-card__sport {{ class }}" size="medium" name="{{ card.mainIcon }}"></mlp-ng-icon>
</ng-template>


<ng-template #heading let-default let-class="class">
    <h2 class="sg-heading__h3 sg-card__title {{ class }}" [ngClass]="{'sg-card__title--secondary-title-color': card?.titleStyle}">
        <a [routerLink]="card.link" class="sg-card__link" *ngIf="card.link">{{ card.name }}</a>
        <ng-container *ngIf="!card.link">{{ card.name }}</ng-container>
    </h2>
    <div class="sg-divider__short mb-2"></div>
</ng-template>
